/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateManagedHiringRequestBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetManagedHiringRequestsResponse } from '../models';
// @ts-ignore
import type { GetOrgManagedHiringRequestsResponse } from '../models';
// @ts-ignore
import type { ManagedHiringRequestDetailResponse } from '../models';
// @ts-ignore
import type { UpdateManagedHiringRequestBody } from '../models';
/**
 * ManagedHiringApiApi - axios parameter creator
 */
export const ManagedHiringApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} orgId 
         * @param {CreateManagedHiringRequestBody} createManagedHiringRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managedHiringApiCreateManagedHiringRequest: async (orgId: string, createManagedHiringRequestBody: CreateManagedHiringRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('managedHiringApiCreateManagedHiringRequest', 'orgId', orgId)
            // verify required parameter 'createManagedHiringRequestBody' is not null or undefined
            assertParamExists('managedHiringApiCreateManagedHiringRequest', 'createManagedHiringRequestBody', createManagedHiringRequestBody)
            const localVarPath = `/managed-hiring/org/{org_id}/requests`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManagedHiringRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managedHiringApiGetManagedHiringRequest: async (requestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('managedHiringApiGetManagedHiringRequest', 'requestId', requestId)
            const localVarPath = `/managed-hiring/admin/requests/{request_id}`
                .replace('{request_id}', encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [searchQuery] 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managedHiringApiGetManagedHiringRequests: async (page?: number, pageSize?: number, searchQuery?: string | null, status?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/managed-hiring/admin/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managedHiringApiGetOrgManagedHiringRequests: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('managedHiringApiGetOrgManagedHiringRequests', 'orgId', orgId)
            const localVarPath = `/managed-hiring/org/{org_id}/requests`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} requestId 
         * @param {UpdateManagedHiringRequestBody} updateManagedHiringRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managedHiringApiUpdateManagedHiringRequest: async (requestId: string, updateManagedHiringRequestBody: UpdateManagedHiringRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('managedHiringApiUpdateManagedHiringRequest', 'requestId', requestId)
            // verify required parameter 'updateManagedHiringRequestBody' is not null or undefined
            assertParamExists('managedHiringApiUpdateManagedHiringRequest', 'updateManagedHiringRequestBody', updateManagedHiringRequestBody)
            const localVarPath = `/managed-hiring/admin/requests/{request_id}`
                .replace('{request_id}', encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateManagedHiringRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManagedHiringApiApi - functional programming interface
 */
export const ManagedHiringApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ManagedHiringApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} orgId 
         * @param {CreateManagedHiringRequestBody} createManagedHiringRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managedHiringApiCreateManagedHiringRequest(orgId: string, createManagedHiringRequestBody: CreateManagedHiringRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManagedHiringRequestDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managedHiringApiCreateManagedHiringRequest(orgId, createManagedHiringRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagedHiringApiApi.managedHiringApiCreateManagedHiringRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managedHiringApiGetManagedHiringRequest(requestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManagedHiringRequestDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managedHiringApiGetManagedHiringRequest(requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagedHiringApiApi.managedHiringApiGetManagedHiringRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [searchQuery] 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managedHiringApiGetManagedHiringRequests(page?: number, pageSize?: number, searchQuery?: string | null, status?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManagedHiringRequestsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managedHiringApiGetManagedHiringRequests(page, pageSize, searchQuery, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagedHiringApiApi.managedHiringApiGetManagedHiringRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managedHiringApiGetOrgManagedHiringRequests(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrgManagedHiringRequestsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managedHiringApiGetOrgManagedHiringRequests(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagedHiringApiApi.managedHiringApiGetOrgManagedHiringRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} requestId 
         * @param {UpdateManagedHiringRequestBody} updateManagedHiringRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managedHiringApiUpdateManagedHiringRequest(requestId: string, updateManagedHiringRequestBody: UpdateManagedHiringRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManagedHiringRequestDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managedHiringApiUpdateManagedHiringRequest(requestId, updateManagedHiringRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagedHiringApiApi.managedHiringApiUpdateManagedHiringRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ManagedHiringApiApi - factory interface
 */
export const ManagedHiringApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ManagedHiringApiApiFp(configuration)
    return {
        /**
         * 
         * @param {ManagedHiringApiApiManagedHiringApiCreateManagedHiringRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managedHiringApiCreateManagedHiringRequest(requestParameters: ManagedHiringApiApiManagedHiringApiCreateManagedHiringRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<ManagedHiringRequestDetailResponse> {
            return localVarFp.managedHiringApiCreateManagedHiringRequest(requestParameters.orgId, requestParameters.createManagedHiringRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManagedHiringApiApiManagedHiringApiGetManagedHiringRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managedHiringApiGetManagedHiringRequest(requestParameters: ManagedHiringApiApiManagedHiringApiGetManagedHiringRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<ManagedHiringRequestDetailResponse> {
            return localVarFp.managedHiringApiGetManagedHiringRequest(requestParameters.requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManagedHiringApiApiManagedHiringApiGetManagedHiringRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managedHiringApiGetManagedHiringRequests(requestParameters: ManagedHiringApiApiManagedHiringApiGetManagedHiringRequestsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetManagedHiringRequestsResponse> {
            return localVarFp.managedHiringApiGetManagedHiringRequests(requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManagedHiringApiApiManagedHiringApiGetOrgManagedHiringRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managedHiringApiGetOrgManagedHiringRequests(requestParameters: ManagedHiringApiApiManagedHiringApiGetOrgManagedHiringRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOrgManagedHiringRequestsResponse> {
            return localVarFp.managedHiringApiGetOrgManagedHiringRequests(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManagedHiringApiApiManagedHiringApiUpdateManagedHiringRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managedHiringApiUpdateManagedHiringRequest(requestParameters: ManagedHiringApiApiManagedHiringApiUpdateManagedHiringRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<ManagedHiringRequestDetailResponse> {
            return localVarFp.managedHiringApiUpdateManagedHiringRequest(requestParameters.requestId, requestParameters.updateManagedHiringRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for managedHiringApiCreateManagedHiringRequest operation in ManagedHiringApiApi.
 */
export interface ManagedHiringApiApiManagedHiringApiCreateManagedHiringRequestRequest {
    readonly orgId: string

    readonly createManagedHiringRequestBody: CreateManagedHiringRequestBody
}

/**
 * Request parameters for managedHiringApiGetManagedHiringRequest operation in ManagedHiringApiApi.
 */
export interface ManagedHiringApiApiManagedHiringApiGetManagedHiringRequestRequest {
    readonly requestId: string
}

/**
 * Request parameters for managedHiringApiGetManagedHiringRequests operation in ManagedHiringApiApi.
 */
export interface ManagedHiringApiApiManagedHiringApiGetManagedHiringRequestsRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly searchQuery?: string | null

    readonly status?: string | null
}

/**
 * Request parameters for managedHiringApiGetOrgManagedHiringRequests operation in ManagedHiringApiApi.
 */
export interface ManagedHiringApiApiManagedHiringApiGetOrgManagedHiringRequestsRequest {
    readonly orgId: string
}

/**
 * Request parameters for managedHiringApiUpdateManagedHiringRequest operation in ManagedHiringApiApi.
 */
export interface ManagedHiringApiApiManagedHiringApiUpdateManagedHiringRequestRequest {
    readonly requestId: string

    readonly updateManagedHiringRequestBody: UpdateManagedHiringRequestBody
}

/**
 * ManagedHiringApiApi - object-oriented interface
 */
export class ManagedHiringApiApi extends BaseAPI {
    /**
     * 
     * @param {ManagedHiringApiApiManagedHiringApiCreateManagedHiringRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public managedHiringApiCreateManagedHiringRequest(requestParameters: ManagedHiringApiApiManagedHiringApiCreateManagedHiringRequestRequest, options?: RawAxiosRequestConfig) {
        return ManagedHiringApiApiFp(this.configuration).managedHiringApiCreateManagedHiringRequest(requestParameters.orgId, requestParameters.createManagedHiringRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManagedHiringApiApiManagedHiringApiGetManagedHiringRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public managedHiringApiGetManagedHiringRequest(requestParameters: ManagedHiringApiApiManagedHiringApiGetManagedHiringRequestRequest, options?: RawAxiosRequestConfig) {
        return ManagedHiringApiApiFp(this.configuration).managedHiringApiGetManagedHiringRequest(requestParameters.requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManagedHiringApiApiManagedHiringApiGetManagedHiringRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public managedHiringApiGetManagedHiringRequests(requestParameters: ManagedHiringApiApiManagedHiringApiGetManagedHiringRequestsRequest = {}, options?: RawAxiosRequestConfig) {
        return ManagedHiringApiApiFp(this.configuration).managedHiringApiGetManagedHiringRequests(requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManagedHiringApiApiManagedHiringApiGetOrgManagedHiringRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public managedHiringApiGetOrgManagedHiringRequests(requestParameters: ManagedHiringApiApiManagedHiringApiGetOrgManagedHiringRequestsRequest, options?: RawAxiosRequestConfig) {
        return ManagedHiringApiApiFp(this.configuration).managedHiringApiGetOrgManagedHiringRequests(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManagedHiringApiApiManagedHiringApiUpdateManagedHiringRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public managedHiringApiUpdateManagedHiringRequest(requestParameters: ManagedHiringApiApiManagedHiringApiUpdateManagedHiringRequestRequest, options?: RawAxiosRequestConfig) {
        return ManagedHiringApiApiFp(this.configuration).managedHiringApiUpdateManagedHiringRequest(requestParameters.requestId, requestParameters.updateManagedHiringRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}

